'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CLASS_VISIBLE = exports.PRODUCT_REVIEW_STARS = exports.PRODUCT_REVIEW_SCROLL = exports.PRODUCT_REVIEWS = exports.PRODUCT_BUY_NOW = exports.PRODUCT_STICKY_TOP = exports.PRODUCT_ALTERNATE_PAYMENT_MONEY = exports.PRODUCT_COMPARE_MONEY = exports.PRODUCT_MONEY = exports.PRODUCT_ADD = exports.PRODUCT_TEMPLATE_CONTAINER = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _pcSlateTools = require('@process-creative/pc-slate-tools');

var _Swatch = require('./../objects/swatch/Swatch');

var _ProductTemplateQuantitySelector = require('./../objects/quantity/ProductTemplateQuantitySelector');

var _AddToCartButton = require('./../objects/product/AddToCartButton');

var _Responsive = require('./../settings/Responsive');

var ResponsiveSizes = _interopRequireWildcard(_Responsive);

require('./../sections/product-recommendations/ProductRecommendations');

var _InfoModal = require('../objects/content/InfoModal');

require('./../sections/product-benefits/ProductBenefits');

require('./../sections/product-carousel/ProductCarousel');

require('./../sections/product-description/ProductDescription');

require('./../sections/free-sample/FreeSampleCarousel');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//Selectors
var PRODUCT_TEMPLATE_CONTAINER = exports.PRODUCT_TEMPLATE_CONTAINER = '[data-product-template]'; /*
                                                                                                  *  Product Template Scripts
                                                                                                  *    Scripts that are only meant to run on the Product Template.
                                                                                                  *
                                                                                                  *  Version:
                                                                                                  *    1.0.0 - 2020/07/06
                                                                                                  */

var PRODUCT_ADD = exports.PRODUCT_ADD = '[data-product-template-add-to-cart]';
var PRODUCT_MONEY = exports.PRODUCT_MONEY = '[data-product-money]';
var PRODUCT_COMPARE_MONEY = exports.PRODUCT_COMPARE_MONEY = '[data-product-compare-money]';
var PRODUCT_ALTERNATE_PAYMENT_MONEY = exports.PRODUCT_ALTERNATE_PAYMENT_MONEY = '[data-alternate-money-price]';
var PRODUCT_STICKY_TOP = exports.PRODUCT_STICKY_TOP = '[data-product-sticky-top]';
var PRODUCT_BUY_NOW = exports.PRODUCT_BUY_NOW = '[data-buy-now]';
var PRODUCT_REVIEWS = exports.PRODUCT_REVIEWS = '[data-product-reviews]';
var PRODUCT_REVIEW_SCROLL = exports.PRODUCT_REVIEW_SCROLL = '[data-review-scroll]';
var PRODUCT_REVIEW_STARS = exports.PRODUCT_REVIEW_STARS = '[data-review-stars]';

var CLASS_VISIBLE = exports.CLASS_VISIBLE = 'is-visible';

var ProductTemplate = function () {
  function ProductTemplate(container) {
    var _this = this;

    (0, _classCallCheck3.default)(this, ProductTemplate);

    //Elements
    this.container = container;

    this.productMoney = container.find(PRODUCT_MONEY);
    this.productCompare = container.find(PRODUCT_COMPARE_MONEY);
    this.alternatePaymentPrice = container.find(PRODUCT_ALTERNATE_PAYMENT_MONEY);
    this.productReviews = $(document).find(PRODUCT_REVIEWS).first();

    //Setup Product Swatches Widget, Quantity and Add to cart
    this.swatches = new _Swatch.Swatch(this.container);
    this.quantitySelector = new _ProductTemplateQuantitySelector.ProductTemplateQuantitySelector(this, this.container);
    this.addToCart = new _AddToCartButton.AddToCartButton(this, this.container.find(PRODUCT_ADD), this.container);
    this.infoModal = new _InfoModal.InfoModal(container.find(_InfoModal.INFO_MODAL_CONTAINER));

    $(document).on(_Swatch.ON_VARIANT_CHANGE, function (e, variant) {
      return _this.onVariantChanged(variant);
    });
    $(document).on('click touchend', PRODUCT_BUY_NOW, function (e) {
      return _this.buyNow(e);
    });
    $(document).on('click touch', PRODUCT_REVIEW_SCROLL, function (e) {
      return _this.scrollToReviews(e);
    });
    $(document).on('click touch', PRODUCT_REVIEW_STARS, function (e) {
      return _this.scrollToReviews(e);
    });
  }

  (0, _createClass3.default)(ProductTemplate, [{
    key: 'onVariantChanged',
    value: function onVariantChanged(variant) {
      var price = variant.price,
          compare_at_price = variant.compare_at_price;

      //Adjust Price Display

      if (!price || price <= 0) {
        this.productMoney.removeAttr('data-money'); //Stops any currency converters attempting to convert.
        this.productMoney.html('FREE'); //TODO: Make this not hard coded.
      } else {
        this.productMoney.attr('data-money', price);
        this.productMoney.html((0, _pcSlateTools.printMoney)(price));
        this.alternatePaymentPrice.html((0, _pcSlateTools.printMoney)(price / 4, 'money_format'));
      }

      //Adjust compare price display
      if (!this.productCompare) return;
      if (!compare_at_price || compare_at_price <= price) {
        this.productCompare.removeAttr('data-money');
        this.productCompare.html('');
      } else {
        this.productCompare.attr('data-money', compare_at_price);
        this.productCompare.html((0, _pcSlateTools.printMoney)(compare_at_price));
      }
    }
  }, {
    key: 'buyNow',
    value: function buyNow(e) {
      e.preventDefault();
      e.stopPropagation();

      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  }, {
    key: 'scrollToReviews',
    value: function scrollToReviews(e) {
      e.preventDefault();
      e.stopPropagation();

      var offset = this.productReviews[0].getBoundingClientRect().top + window.scrollY;

      window.scrollTo({
        top: offset,
        behavior: "smooth"
      });
    }
  }]);
  return ProductTemplate;
}();

$(document).ready($(PRODUCT_TEMPLATE_CONTAINER).each(function (e, i) {
  return new ProductTemplate($(i));
}));